import React from "react";
import { Card, CardBody, Button, Input, Row, Col, Badge } from "reactstrap";
import api from "./../../../Api.js";
import moment from "moment";

class CertificateVerify extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      code: '',
      result: null,
      loading: false,
      searched: false
    };
  }

  async verify() {
    if (!this.state.code.trim()) return;

    this.setState({ loading: true, result: null, searched: false });

    try {
      var res = await api.verifyCertificate(this.state.code.trim());
      this.setState({ result: res.data, loading: false, searched: true });
    } catch (err) {
      this.setState({ result: { valid: false }, loading: false, searched: true });
    }
  }

  getSkillColor(level) {
    var colors = {
      'Avançado': 'success',
      'Intermediário': 'warning',
      'Iniciante': 'info'
    };
    return colors[level] || 'secondary';
  }

  render() {

    return (
      <Card className="shadow">
        <CardBody>
          <h5 className="mb-3">
            <i className="fas fa-search mr-2" />
            Verificar Certificado
          </h5>

          <Row className="mb-3">
            <Col md="8">
              <Input
                type="text"
                placeholder="Digite o código do certificado (ex: CERT-2026-ABCD1234)"
                value={this.state.code}
                onChange={(e) => this.setState({ code: e.target.value })}
                onKeyPress={(e) => e.key === 'Enter' && this.verify()}
              />
            </Col>
            <Col md="4">
              <Button
                color="primary"
                block
                onClick={() => this.verify()}
                disabled={this.state.loading}
              >
                {this.state.loading ? (
                  <i className="fas fa-spinner fa-spin" />
                ) : (
                  <React.Fragment>
                    <i className="fas fa-check-circle mr-2" />
                    Verificar
                  </React.Fragment>
                )}
              </Button>
            </Col>
          </Row>

          {this.state.searched && this.state.result && (
            <div className="mt-3">
              {this.state.result.valid ? (
                <div className="alert alert-success d-flex align-items-start">
                  <i className="fas fa-check-circle fa-2x mr-3 mt-1" style={{ color: '#28a745' }} />
                  <div>
                    <h5 className="alert-heading mb-1">Certificado Válido</h5>
                    <p className="mb-1">
                      <strong>{this.state.result.certificate.userName} {this.state.result.certificate.userLastName || ''}</strong>
                    </p>
                    {this.state.result.certificate.courseName && (
                      <p className="mb-1" style={{ fontSize: '0.9rem' }}>
                        <i className="fas fa-book mr-1" />
                        Curso: <strong>{this.state.result.certificate.courseName}</strong>
                      </p>
                    )}
                    <div className="d-flex flex-wrap">
                      <Badge color={this.getSkillColor(this.state.result.certificate.skillLevel)} className="mr-2 mb-1">
                        {this.state.result.certificate.skillLevel}
                      </Badge>
                      {this.state.result.certificate.totalHours > 0 && (
                        <Badge color="info" className="mr-2 mb-1">
                          {parseFloat(this.state.result.certificate.totalHours).toFixed(0)}h
                        </Badge>
                      )}
                      <Badge color="secondary" className="mb-1">
                        {moment(this.state.result.certificate.completionDate).format('DD/MM/YYYY')}
                      </Badge>
                    </div>
                    <small className="text-muted mt-1 d-block">
                      Código: {this.state.result.certificate.certificateCode}
                    </small>
                  </div>
                </div>
              ) : (
                <div className="alert alert-danger d-flex align-items-center">
                  <i className="fas fa-times-circle fa-2x mr-3" />
                  <div>
                    <h5 className="alert-heading mb-0">Certificado Inválido</h5>
                    <p className="mb-0">O código informado não corresponde a nenhum certificado.</p>
                  </div>
                </div>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    );

  }

}

export default CertificateVerify;
